import { BsFillQuestionCircleFill, BsInfoCircleFill, BsClockHistory } from 'react-icons/bs'
import { Link, Route, BrowserRouter as Router } from 'react-router-dom'
import React, { useState, useEffect } from 'react'

import BtBig from '../../components/BtBig'
import { Context } from '../../store/Store'
import Subtitle from '../../components/Subtitle'
import Title from '../../components/Title'
import { Transition } from '@headlessui/react'
import boiteSvg from '../../svg/ic-boite.svg'
// Icones
import livreSvg from '../../svg/ic-livre.svg'

export function PoHome() {
  const { app } = React.useContext(Context)
  const [hasDrafts, setHasDrafts] = useState(false)
  
  useEffect(() => {
    // Vérifier s'il existe des brouillons pour cet utilisateur
    const draftKeys = Object.keys(localStorage).filter(key => key.startsWith(`poform_${app.profil.id}`))
    setHasDrafts(draftKeys.length > 0)
  }, [])
  
  return (
    <div className="max-w-7xl mx-auto px-6 py-6">
      <div>
        <div>
          <Subtitle title="Accueil" />
          <Title title="Aides" classCustom={'mb-4'} />
        </div>
      </div>
      
      {hasDrafts && (
        <div className="mb-6 bg-base-light/10 p-4 rounded-md border border-base-light/30">
          <div className="flex items-center">
            <BsClockHistory className="text-base mr-2 text-xl" />
            <h3 className="text-lg font-medium text-base-dark">Vous avez des demandes en cours</h3>
          </div>
          <p className="mt-1 text-sm text-base mb-3">
            Vous avez commencé des demandes d'aides que vous n'avez pas encore finalisées. Vous pouvez les reprendre à tout moment.
          </p>
          <Link 
            to="po-drafts" 
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-base hover:bg-base-dark"
          >
            Voir mes demandes en cours
          </Link>
        </div>
      )}
      
      <div className="p-4 border-2 my-6">
        <div className="grid xs:grid-cols-2 lg:grid-cols-3">
          <div className="border-r-2 p-4">
            <Link to="po-home-pec">
              <BtBig
                icon={livreSvg}
                title={`Aides ${new Date().getFullYear()}`}
                classCustom="bg-gray-200 text-center"
                titleColor="text-black"
              />
            </Link>
          </div>
          <div className="p-4">
            <Link to="po-home-pav">
              <BtBig
                icon={boiteSvg}
                title={`Projet ${new Date().getFullYear() + 1}`}
                classCustom="bg-gray-200 text-center"
                titleColor="text-black"
              />
            </Link>
          </div>
          <div className="p-4">
            <Link to="po-drafts">
              <BtBig
                icon={boiteSvg}
                title="Demandes en cours"
                classCustom="bg-base-light/20 text-center"
                titleColor="text-base"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
